import React, { useState, useEffect, useRef, useMemo } from "react";
import { API_BASE } from "../api/config";
import { FaTable, FaSearch } from "react-icons/fa";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ import auth

const OTP_SESSION_KEY = "self_order_otp_verified";

function SelfOrderByOtp() {
  const { username } = useAuth(); // ✅ get branch
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [items, setItems] = useState([]);
  const [kotItems, setKotItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [branchInfo, setBranchInfo] = useState(null); // ✅ store branch info
  const searchRef = useRef(null); // ✅ ref for search input
  const navigate = useNavigate();
  const [showKotDetails, setShowKotDetails] = useState(false);
  const [mobileKotOpen, setMobileKotOpen] = useState(false);
  
  const [showOtpPopup, setShowOtpPopup] = useState(true);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const DUMMY_OTP = "1234";
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [company, setCompany] = useState(null);
  const [otpStep, setOtpStep] = useState(1); // 1 = details, 2 = otp

  // ✅ Added personalNumber state & ref
  const [personalNumber, setPersonalNumber] = useState("");
  const [membershipId, setMembershipId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const personalRef = useRef(null);
  const membershipRef = useRef(null);
  const mobileRef = useRef(null);
  const otpRef = useRef(null);

  const [origins, setOrigins] = useState([]);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [postOtpStep, setPostOtpStep] = useState(0); 
  // 0 = show branches
  // 1 = show tables

  const [todayKots, setTodayKots] = useState([]);
  const [loadingKots, setLoadingKots] = useState(false);

  const [showCheckoutPopup, setShowCheckoutPopup] = useState(false);
  const [splitMemberships, setSplitMemberships] = useState([""]);
  const firstMembershipRef = useRef(null);
  const [checkoutTableName, setCheckoutTableName] = useState("");
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState("");

  const normalize = (value) =>
    String(value || "")
      .toLowerCase()
      .trim();

  const { branch } = useParams(); // ✅ works now
  
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const filteredTodayKots = useMemo(() => {
    if (!selectedTable || !selectedBranch) return [];

    return todayKots.filter(
      (k) =>
        normalize(k.table_name) === normalize(selectedTable.name) &&
        normalize(k.branch) === normalize(selectedBranch.name)
    );
  }, [todayKots, selectedTable, selectedBranch]);

  const getKotStatus = (status) => {
    switch (String(status)) {
      case "0":
        return { label: "New", color: "bg-gray-500" };
      case "1":
        return { label: "OrderPlaced", color: "bg-orange-500" };
      case "2":
        return { label: "Preparing", color: "bg-green-500" };
      case "3":
        return { label: "Ready", color: "bg-blue-500" };
      case "4":
        return { label: "Delivered", color: "bg-blue-500" };
      default:
        return { label: "Unknown", color: "bg-gray-600" };
    }
  };

  useEffect(() => {
    if (showCheckoutPopup) {
      setTimeout(() => {
        firstMembershipRef.current?.focus();
      }, 100);
    }
  }, [showCheckoutPopup]);

  useEffect(() => {
    console.log("Today Kots:", todayKots);
  }, [todayKots]);

  useEffect(() => {
    console.log("Filtered Kots:", filteredTodayKots);
  }, [filteredTodayKots]);
    
  const fetchOrigins = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=courses`
      );
      const data = await res.json();
      if (Array.isArray(data)) {
        setOrigins(data);
      }
    } catch (error) {
      console.error("Error fetching origins:", error);
    }
  };

  useEffect(() => {
    fetchOrigins();
  }, []);

  const handleBackToBranches = () => {
    setSelectedBranch(null);
    setSelectedTable(null);
    setSelectedCategory(null);
    setSelectedOrigin(null);
    setKotItems([]);
    setTables([]);
    setTodayKots([]);
  };
    
  const generateOrderRef = () => {
    const now = new Date();
    const Y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const H = String(now.getHours()).padStart(2, "0");
    const i = String(now.getMinutes()).padStart(2, "0");
    const s = String(now.getSeconds()).padStart(2, "0");
    const random = Math.floor(Math.random() * (100 - 10 + 1)) + 10; // 10–100
    return `${Y}${m}${d}${H}${i}${s}${random}`;
  };

  const orderRef = generateOrderRef();
    
  const sendOtpSms = async () => {
    if (!personalNumber.trim()) {
      setOtpError("Personal Number is required");
      personalRef.current?.focus();
      return;
    }

    if (!membershipId.trim()) {
      setOtpError("Membership ID is required");
      membershipRef.current?.focus();
      return;
    }

    if (mobileNumber.length !== 10) {
      setOtpError("Enter valid 10-digit mobile number");
      mobileRef.current?.focus();
      return;
    }

    const otp = Math.floor(1000 + Math.random() * 9000);
    setGeneratedOtp(otp);
       
    // ✅ Included personal_number in the check_otp API query
    const res = await fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=check_otp&personal_number=${encodeURIComponent(personalNumber)}&mobile=${mobileNumber}&otp=${otp}`
    );

    const result = await res.text();
    console.log(result);

    if (result.includes("SMS sent successfully")) {
      setOtpError("");
      setOtpStep(2); // move to OTP input
    } else {
      setOtpError("SMS sending failed");
    }
  };    
    
  const handleVerifyOtp = () => {
    if (otp === String(generatedOtp)) {
      // ✅ SAVE SESSION FLAG
      sessionStorage.setItem(OTP_SESSION_KEY, "true");
      setShowOtpPopup(false);
      setPostOtpStep(0);
      setSelectedBranch(null);
      setSelectedTable(null);
      setKotItems([]);
      setOtpError("");
    } else {
      setOtpError("Invalid OTP");
    }
  };

  useEffect(() => {
    const isVerified = sessionStorage.getItem(OTP_SESSION_KEY);
    if (isVerified === "true") {
      setShowOtpPopup(false);
    }
  }, []);

  const fetchTodayKotsByBranch = async (branchName) => {
    setLoadingKots(true);
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_today_kots_by_navy&condition=branch&branch=${encodeURIComponent(
          branchName
        )}&login_type=staff&login_name=${encodeURIComponent(username)}`
      );
      const data = await res.json();
      setTodayKots(Array.isArray(data) ? data : data?.data || []);
    } catch {
      setTodayKots([]);
    } finally {
      setLoadingKots(false);
    }
  };
    
  const getExistingMembershipsForTable = () => {
    if (!selectedTable) return [];
    const kot = todayKots.find(
      (k) => k.table_name === selectedTable.name
    );
    if (!kot || !kot.additional_member_ship) return [];
    return kot.additional_member_ship
      .split(",")
      .map((m) => m.trim())
      .filter(Boolean);
  };

  useEffect(() => {
    if (!selectedBranch || !selectedTable) return;
    fetchTodayKotsByBranch(selectedBranch.name);
    const interval = setInterval(() => {
      fetchTodayKotsByBranch(selectedBranch.name);
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedBranch, selectedTable]);

  useEffect(() => {
    if (showOtpPopup && otpStep === 1 && personalRef.current) {
      personalRef.current?.focus();
    }
    if (showOtpPopup && otpStep === 2 && otpRef.current) {
      otpRef.current.focus();
    }
  }, [showOtpPopup, otpStep]);

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, [selectedCategory, selectedTable]);

  const fetchTables = async (branchName = null) => {
    if (!branchName) return;
    try {
      const response = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=tables&branch=${encodeURIComponent(branchName)}&condition=branch`
      );
      const data = await response.json();
      if (!Array.isArray(data)) {
        setTables([]);
        return;
      }
      const mappedTables = data.map((t, idx) => ({
        id: idx + 1,
        name: t.table_name,
        seats: 4,
        status: t.table_booked_status === "1" ? "Occupied" : "Available",
      }));
      setTables(mappedTables);
    } catch (error) {
      console.error("Error fetching tables:", error);
      setTables([]);
    }
  };

  useEffect(() => {
    if (!showOtpPopup) return;
    const timer = setTimeout(() => {
      if (otpStep === 1 && personalRef.current) {
        personalRef.current?.focus();
      }
      if (otpStep === 2 && otpRef.current) {
        otpRef.current.focus();
      }
    }, 0);
    return () => clearTimeout(timer);
  }, [showOtpPopup, otpStep]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=groups&transac=get`
        );
        const data = await res.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, [branch]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=items&transac=get`
        );
        const data = await res.json();
        if (!Array.isArray(data)) {
          setItems([]);
          return;
        }
        const filtered = data.filter((item) => {
          if (!item.branch || !selectedBranch?.name) return false;
          const itemBranches = item.branch
            .split(",")
            .map((b) => b.trim().toLowerCase());
          return itemBranches.includes(
            selectedBranch.name.trim().toLowerCase()
          );
        });
        setItems(filtered);
      } catch (error) {
        console.error("Error fetching items:", error);
        setItems([]);
      }
    };
    if (selectedBranch) {
      fetchItems();
    }
  }, [selectedBranch]);

  useEffect(() => {
    const fetchBranchInfo = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches`
        );
        const data = await res.json();
        if (data && data.length > 0) {
          setBranchInfo(data[0]);
        }
      } catch (error) {
        console.error("Error fetching branch info:", error);
      }
    };
    fetchBranchInfo();
  }, [branch]);
  
  const fetchBranches = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches`
      );
      const data = await res.json();
      if (Array.isArray(data)) {
        setBranches(data);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleSelectBranch = (branch) => {
    setSelectedBranch(branch);
    setSelectedTable(null);
    setSelectedCategory(null);
    setKotItems([]);
    setTodayKots([]);
    fetchTables(branch.name);
    fetchTodayKotsByBranch(branch.name);
  };

  const fetchCompanyDetails = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=company`
      );
      const result = await res.json();
      if (
        result.status === "ok" &&
        Array.isArray(result.data) &&
        result.data.length > 0
      ) {
        setCompany(result.data[0]);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const filteredItems = searchTerm
    ? items.filter((item) =>
        item.item_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : selectedCategory
    ? items.filter((item) => item.group === selectedCategory.item_name)
    : [];

  const handleSelectTable = (table) => {
    if (showOtpPopup) return;
    setSelectedTable(table);
    setSelectedOrigin(null);
    setSelectedCategory(null);
    setKotItems([]);
    setSearchTerm("");
    setSelectedItem(null);
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    setSearchTerm("");
    setSelectedItem(null);
  };

  const handleAddItem = (item) => {
    setSelectedItem(item.id);
    const existing = kotItems.find((i) => i.id === item.id);
    if (existing) {
      setKotItems(
        kotItems.map((i) =>
          i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
        )
      );
    } else {
      setKotItems([
        ...kotItems,
        {
          ...item,
          quantity: 1,
          name: item.item_name,
          price: item.item_price,
          group_name: item.group,
        },
      ]);
    }
    setSearchTerm("");
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleIncrease = (item) => {
    setKotItems(
      kotItems.map((i) =>
        i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
      )
    );
  };

  const handleDecrease = (item) => {
    setKotItems(
      kotItems
        .map((i) =>
          i.id === item.id ? { ...i, quantity: i.quantity - 1 } : i
        )
        .filter((i) => i.quantity > 0)
    );
  };

  const groupedKots = useMemo(() => {
    const map = {};
    filteredTodayKots.forEach((k) => {
      if (!map[k.order_ref]) map[k.order_ref] = [];
      map[k.order_ref].push(k);
    });
    return map;
  }, [filteredTodayKots]);
  
  const handleFinalizeKOT = async () => {
    // 🚫 HARD VALIDATION FOR PERSONAL NUMBER
    if (!personalNumber || !personalNumber.trim()) {
      alert("Personal Number is required to place order");
      setShowOtpPopup(true);
      setOtpStep(1);
      return;
    }

    if (!membershipId || !membershipId.trim()) {
      alert("Membership ID is required to place order");
      setShowOtpPopup(true);
      setOtpStep(1);
      return;
    }

    if (!mobileNumber || mobileNumber.length !== 10) {
      alert("Valid 10-digit mobile number is required");
      setShowOtpPopup(true);
      setOtpStep(1);
      return;
    }

    if (!selectedTable || kotItems.length === 0) {
      alert("Select table and add items first!");
      return;
    }

    setProcessing(true);

    try {
      const payload = kotItems.map((item) => ({
        table_name: selectedTable.name,
        item_name: item.name,
        item_qty: item.quantity,
        group_name: item.group_name,
        item_price: item.price,
        branch: selectedBranch?.name || branch,
      }));

      // ✅ Added personal_number to insert_kot API URL
      await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=insert_kot` +
        `&username=${encodeURIComponent(username)}` +
        `&branch=${encodeURIComponent(selectedBranch?.name || branch)}` +
        `&order_ref=${orderRef}` +
        `&personal_number=${encodeURIComponent(personalNumber)}` +
        `&member_ship=${encodeURIComponent(membershipId)}` +
        `&mobile=${encodeURIComponent(mobileNumber)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      
      const srRes = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_kot_by_order_ref&order_ref=${orderRef}`
      );
      const srData = await srRes.json();
      const daySrNo = srData?.[0]?.day_srno || "—";
      
      const now = new Date();
      const dateTimeStr = now.toLocaleString();

      setSelectedTable(null);
      setSelectedCategory(null);
      setKotItems([]);
      setSearchTerm("");
      setSelectedItem(null);
      setProcessing(false);

      setShowOtpPopup(true);
      setShowSuccessPopup(true);
      fetchTables();

    } catch (error) {
      console.error("Error sending KOT to server:", error);
      setProcessing(false);
    }
  };

  const filteredKots = Object.entries(groupedKots).filter(
    ([ref, items]) => items.every((i) => !i.additional_member_ship)
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-blue-950 to-black text-white flex flex-col md:flex-row gap-4 p-3 relative pb-48 md:pb-4 overflow-y-auto">

      {/* Left Panel */}
      <div className="flex-1 flex flex-col gap-4">
        <div className="sticky top-0 z-40 bg-black/90 backdrop-blur border-b border-blue-900 px-4 py-3">
          <h1 className="text-xl md:text-2xl font-bold text-center text-blue-400">
            {company?.company_name || "Company Name"}
          </h1>
          <p className="text-center text-xs text-gray-400">
            {company?.company_address || ""}
          </p>
        </div>

        {processing && (
          <div className="absolute inset-0 bg-black/80 flex items-center justify-center z-50">
            <div className="bg-blue-950 text-white px-6 py-4 rounded-lg shadow-lg text-center animate-pulse">
              <h2 className="text-xl font-bold mb-2">Processing...</h2>
              <p className="text-gray-300">Please wait a moment.</p>
            </div>
          </div>
        )}

        {!selectedBranch && (
          <div className="px-4 mt-4">
            <h2 className="text-lg font-bold mb-3 text-center text-blue-300">
              Select Restaurant 🏬
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {branches.map((b) => (
                <div
                  key={b.id}
                  onClick={() => handleSelectBranch(b)}
                  className="p-3 rounded-lg bg-blue-950 hover:bg-blue-900 cursor-pointer text-center shadow transition"
                >
                  <h3 className="font-semibold text-sm">{b.name}</h3>
                  <p className="text-xs text-gray-400 mt-1">{b.address}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {selectedBranch && !selectedTable && (
          <>
            <button
              onClick={handleBackToBranches}
              className="mb-3 px-3 py-1 bg-gray-700 rounded hover:bg-gray-600 w-fit"
            >
              ← Back to Branches
            </button>

            <h1 className="text-2xl font-bold">Select Table 🪑</h1>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 overflow-y-auto max-h-[80vh] pb-2">
              {tables.length === 0 ? (
                <p className="text-gray-400 text-center col-span-full">No tables available for this branch.</p>
              ) : (
                tables.map((table) => (
                  <div
                    key={table.id}
                    className={`p-3 rounded-lg shadow cursor-pointer text-center transition ${
                      table.status === "Available"
                        ? "bg-blue-950 hover:bg-blue-900 text-white"
                        : "bg-black/80 border border-red-500 text-red-300"
                    }`}
                    onClick={() => handleSelectTable(table)}
                  >
                    <h2 className="text-sm font-semibold mb-1">{table.name}</h2>
                    <div className="flex justify-center mb-1">
                      <FaTable className="text-xl" />
                    </div>
                    <p
                      className={`text-xs font-medium ${
                        table.status === "Available" ? "text-green-400" : "text-red-400"
                      }`}
                    >
                      {table.status}
                    </p>
                  </div>
                ))
              )}
            </div>
          </>
        )}

        {selectedTable && (
          <>
            <button
              className="px-3 py-1 bg-blue-700 rounded hover:bg-blue-800 w-full md:w-auto"
              onClick={() => {
                setSelectedTable(null);
                setSelectedBranch(null);
                setSelectedCategory(null);
                setKotItems([]);
              }}
            >
              Back to Tables
            </button>

            {selectedTable && (
              <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 mb-2">
                {origins.map((origin) => (
                  <button
                    key={origin.id}
                    onClick={() => {
                      setSelectedOrigin(origin);
                      setSelectedCategory(null);
                    }}
                    className={`p-2 rounded text-sm font-semibold transition ${
                      selectedOrigin?.id === origin.id
                        ? "bg-orange-900 text-white border border-[#3a2216]"
                        : "bg-[#4b2e1e] text-white hover:bg-orange-800"
                    }`}
                  >
                    {origin.item_name}
                  </button>
                ))}
              </div>
            )}

            {selectedOrigin && (
              <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 overflow-x-auto max-h-[150px] pb-1">
                {categories
                  .filter((cat) =>
                    selectedOrigin ? cat.course_name === selectedOrigin.item_name : true
                  )
                  .map((cat) => {
                    const count = items.filter((item) => item.group === cat.item_name).length;
                    return (
                      <button
                        key={cat.id}
                        className={`flex flex-col items-center p-2 rounded text-sm font-semibold transition ${
                          selectedCategory?.item_name === cat.item_name
                            ? "bg-black text-blue-400 border border-blue-500"
                            : "bg-blue-950 text-white hover:bg-blue-800"
                        }`}
                        onClick={() => handleSelectCategory(cat)}
                      >
                        <span>{cat.item_name}</span>
                        <span className="text-xs text-gray-300 mt-1">({count})</span>
                      </button>
                    );
                  })}
              </div>
            )}
            
            <div className="relative mb-3">
              <input
                ref={searchRef}
                type="text"
                placeholder="Search items..."
                className="w-full pl-7 pr-2 p-2 rounded bg-black/70 text-white border border-gray-700"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
            </div>

            {kotItems.length > 0 && (
              <div className="md:hidden">
                <button
                  className="px-3 py-1 bg-orange-700 rounded hover:bg-orange-800 w-full md:w-auto"
                  onClick={() => setShowKotDetails(true)}
                >
                  Show Order ({kotItems.reduce((acc, i) => acc + i.quantity, 0)} items - ₹
                  {kotItems
                    .reduce((acc, i) => acc + i.quantity * parseFloat(i.price || 0), 0)
                    .toFixed(2)}
                  )
                </button>
              </div>
            )}

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 overflow-y-auto max-h-[300px] pb-2">
              {filteredItems.map((item) => {
                const isSelected = selectedItem === item.id;
                return (
                  <div
                    key={item.id}
                    className={`flex flex-col items-center justify-center p-2 rounded shadow cursor-pointer transition min-h-[70px] ${
                      isSelected
                        ? "bg-black text-blue-400 border border-blue-500"
                        : "bg-blue-950 text-white hover:bg-blue-800"
                    }`}
                    onClick={() => handleAddItem(item)}
                  >
                    <h3 className="font-semibold text-center text-sm">{item.item_name}</h3>
                    <span className="text-xs">₹{parseFloat(item.item_price).toFixed(2)}</span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>

      {/* Right Panel - KOT */}
      <div className="hidden md:block w-2/5 bg-black/70 p-4 rounded-lg shadow-md h-fit max-h-[calc(100vh-50px)] overflow-y-auto">
        <h2 className="text-xl font-bold mb-3">
          {selectedTable ? `KOT - ${selectedTable.name}` : "KOT"}
        </h2>
        {kotItems.length === 0 ? (
          <p className="text-gray-300">No items added yet.</p>
        ) : (
          <>
            {kotItems.map((item) => (
              <div
                key={item.id}
                className="flex justify-between items-center mb-2 bg-blue-950/70 p-3 rounded"
              >
                <span>{item.name}</span>
                <div className="flex items-center gap-2">
                  <button className="px-2 bg-red-600 rounded" onClick={() => handleDecrease(item)}>-</button>
                  <span>{item.quantity}</span>
                  <button className="px-2 bg-green-600 rounded" onClick={() => handleIncrease(item)}>+</button>
                </div>
              </div>
            ))}
            <hr className="my-3 border-gray-600" />
            <div className="flex justify-between font-bold mb-3">
              <span>Total Items:</span>
              <span>{kotItems.reduce((acc, i) => acc + i.quantity, 0)}</span>
            </div>
            <button
              onClick={handleFinalizeKOT}
              disabled={processing}
              className={`w-full px-4 py-2 font-bold rounded ${
                processing ? "bg-gray-600 cursor-not-allowed" : "bg-blue-700 hover:bg-blue-800"
              }`}
            >
              {processing ? "Processing..." : "Finalize"} ₹
              {kotItems.reduce((acc, i) => acc + i.quantity * parseFloat(i.price || 0), 0).toFixed(2)}
            </button>
          </>
        )}
      </div>

      {/* Mobile Slide-Up KOT Panel */}
      {showKotDetails && (
        <div className="fixed inset-0 bg-black/80 flex flex-col justify-end z-50">
          <div className="bg-gray-900 p-4 rounded-t-2xl max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-lg font-bold">KOT Details</h2>
              <button className="text-gray-300 hover:text-white" onClick={() => setShowKotDetails(false)}>✕</button>
            </div>
            {kotItems.map((item) => (
              <div
                key={item.id}
                className="flex justify-between items-center mb-2 bg-blue-950/70 p-3 rounded"
              >
                <span>{item.name}</span>
                <div className="flex items-center gap-2">
                  <button className="px-2 bg-red-600 rounded" onClick={() => handleDecrease(item)}>-</button>
                  <span>{item.quantity}</span>
                  <button className="px-2 bg-green-600 rounded" onClick={() => handleIncrease(item)}>+</button>
                </div>
              </div>
            ))}
            <hr className="my-3 border-gray-600" />
            <div className="flex justify-between font-bold mb-3">
              <span>Total Items:</span>
              <span>{kotItems.reduce((acc, i) => acc + i.quantity, 0)}</span>
            </div>
            <button
              onClick={handleFinalizeKOT}
              disabled={processing}
              className={`w-full px-4 py-2 font-bold rounded ${
                processing ? "bg-gray-600 cursor-not-allowed" : "bg-blue-700 hover:bg-blue-800"
              }`}
            >
              {processing ? "Processing..." : "Finalize & Print KOT"} ₹
              {kotItems.reduce((acc, i) => acc + i.quantity * parseFloat(i.price || 0), 0).toFixed(2)}
            </button>
          </div>
        </div>
      )}
      
      {/* EXISTING KOTS */}
      {selectedTable && (
        <div className="mt-4 bg-gray-900 p-3 rounded">
          <h3 className="font-bold mb-2">
            Existing KOTs – {selectedTable.name}
          </h3>

          {loadingKots ? (
            <p>Loading...</p>
          ) : filteredKots.length === 0 ? (
            <p className="text-gray-400">No active KOTs</p>
          ) : (
            Object.entries(groupedKots)
              .filter(([ref, items]) =>
                items.every(
                  (i) =>
                    !i.additional_member_ship || 
                    i.additional_member_ship === "" ||
                    i.additional_member_ship === null
                )
              )
              .map(([ref, items]) => {
                return (
                  <div key={ref} className="border p-2 mb-2 rounded">
                    <div className="flex justify-between mb-1">
                      <span>Order #{items[0].day_srno}</span>
                      <span className="text-xs text-gray-500">
                        {items.length} items
                      </span>
                    </div>

                    {items.map((i) => {
                      const status = getKotStatus(i.kot_running_status);
                      return (
                        <div
                          key={i.id}
                          className="flex justify-between items-center text-sm py-0.5"
                        >
                          <span>{i.item_name}</span>
                          <div className="flex items-center gap-2">
                            <span>x{i.item_qty}</span>
                            <span
                              className={`${status.color} px-2 rounded text-black text-[10px]`}
                            >
                              {status.label}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })
          )}
          
          {selectedTable && filteredKots.length > 0 && (
            <div className="mt-3">
              <button
                onClick={() => {
                  const existingMemberships = getExistingMembershipsForTable();
                  setSplitMemberships(
                    existingMemberships.length > 0 ? existingMemberships : [""]
                  );
                  setShowCheckoutPopup(true);
                }}
                className="w-full bg-green-700 hover:bg-green-800 py-2 rounded font-bold"
              >
                Checkout
              </button>
            </div>
          )}
        </div>
      )}
      
      {/* 🔐 OTP POPUP */}
      {showOtpPopup && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center">
          <div className="bg-gray-900 p-6 rounded-lg w-80 shadow-xl">
            <h2 className="text-xl font-bold text-center mb-4 text-blue-400">
              {otpStep === 1 ? "Verify Details" : "Enter OTP"}
            </h2>

            {/* STEP 1 – Personal Number, Membership & Mobile */}
            {otpStep === 1 && (
              <>
                <input
                  ref={personalRef}
                  type="text"
                  value={personalNumber}
                  onChange={(e) => setPersonalNumber(e.target.value)}
                  placeholder="Personal Number *"
                  required
                  className="w-full p-2 mb-3 rounded bg-black text-white border border-gray-700 text-center"
                />
                <input
                  ref={membershipRef}
                  type="text"
                  value={membershipId}
                  onChange={(e) => setMembershipId(e.target.value)}
                  placeholder="Membership ID *"
                  required
                  className="w-full p-2 mb-3 rounded bg-black text-white border border-gray-700 text-center"
                />
                <input
                  ref={mobileRef}
                  type="tel"
                  value={mobileNumber}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    if (val.length <= 10) setMobileNumber(val);
                  }}
                  placeholder="Enter Mobile Number *"
                  required
                  className="w-full p-2 mb-4 rounded bg-black text-white border border-gray-700 text-center"
                />
                
                {otpError && <p className="text-red-400 text-sm text-center mb-2">{otpError}</p>}

                <button
                  onClick={() => {
                    if (!personalNumber.trim()) {
                      setOtpError("Personal Number is required");
                      personalRef.current?.focus();
                      return;
                    }
                    if (!membershipId.trim()) {
                      setOtpError("Membership ID is required");
                      membershipRef.current?.focus();
                      return;
                    }
                    if (mobileNumber.length !== 10) {
                      setOtpError("Enter a valid 10-digit mobile number");
                      mobileRef.current?.focus();
                      return;
                    }

                    setOtpError("");
                    sendOtpSms(); // ✅ CALL SMS FUNCTION HERE
                  }}
                  className="w-full bg-blue-700 hover:bg-blue-800 py-2 rounded font-bold"
                >
                  Send OTP
                </button>
              </>
            )}

            {/* STEP 2 – OTP */}
            {otpStep === 2 && (
              <>
                <input
                  ref={otpRef}
                  type="password"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter OTP"
                  required
                  className="w-full p-2 mb-2 rounded bg-black text-white border border-gray-700 text-center tracking-widest"
                />
                {otpError && <p className="text-red-400 text-sm text-center mb-2">{otpError}</p>}
                <button
                  onClick={handleVerifyOtp}
                  className="w-full bg-blue-700 hover:bg-blue-800 py-2 rounded font-bold"
                >
                  Verify OTP
                </button>
                <button
                  onClick={() => {
                    setOtpStep(1);
                    setOtp("");
                  }}
                  className="w-full mt-2 text-sm text-gray-400 hover:text-white"
                >
                  ← Change details
                </button>
              </>
            )}
          </div>
        </div>
      )}
      
      {/* 🧾 CHECKOUT / SPLIT MEMBERSHIP POPUP */}
      {showCheckoutPopup && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center">
          <div className="bg-gray-900 p-6 rounded-lg w-96 shadow-xl">
            <h2 className="text-xl font-bold text-center mb-4 text-green-400">
              Checkout – Split Membership
            </h2>

            {splitMemberships.map((m, idx) => (
              <div key={idx} className="flex gap-2 mb-2">
                <input
                  ref={idx === 0 ? firstMembershipRef : null}
                  type="text"
                  value={m}
                  onChange={(e) => {
                    const arr = [...splitMemberships];
                    arr[idx] = e.target.value;
                    setSplitMemberships(arr);
                  }}
                  placeholder={`Membership ID ${idx + 1}`}
                  className="flex-1 p-2 rounded bg-black text-white border border-gray-700 text-center"
                />

                {splitMemberships.length > 1 && (
                  <button
                    onClick={() => {
                      const arr = splitMemberships.filter((_, i) => i !== idx);
                      setSplitMemberships(arr);
                    }}
                    className="px-3 bg-red-700 hover:bg-red-800 rounded"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}

            <button
              onClick={() => setSplitMemberships([...splitMemberships, ""])}
              className="w-full mb-3 bg-gray-700 hover:bg-gray-600 py-2 rounded text-sm"
            >
              + Add More Membership
            </button>

            <button
              onClick={async () => {
                const memberships = splitMemberships.filter((m) => m.trim());
                if (!selectedTable.name) {
                  alert("Table not found");
                  return;
                }
                if (memberships.length === 0) {
                  alert("Please enter at least one Membership ID");
                  firstMembershipRef.current?.focus();
                  return;
                }

                try {
                  const url =
                    `${API_BASE}` +
                    "?key=dzital_key" +
                    "&pswd=Hibujji@123" +
                    "&transac=update" +
                    "&table=update_additional_member_ship" +
                    `&condition=${selectedTable.name}`;

                  const response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      memberships: memberships,
                    }),
                  });

                  const text = await response.text();
                  console.log("API STATUS:", response.status);
                  console.log("API RESPONSE:", text);

                  setShowCheckoutPopup(false);
                  setSplitMemberships([""]);
                  setCheckoutTableName("");

                  alert("Additional memberships updated successfully ✅");
                  setShowFeedbackPopup(true);
                } catch (err) {
                  console.error("Membership update failed:", err);
                  alert("Failed to update memberships");
                }
              }}
              className="w-full bg-green-700 hover:bg-green-800 py-2 rounded font-bold"
            >
              Confirm Checkout
            </button>

            <button
              onClick={() => setShowCheckoutPopup(false)}
              className="w-full mt-2 text-sm text-gray-400 hover:text-white"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {showFeedbackPopup && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-white text-black p-6 rounded-lg shadow-lg w-80 text-center">
            <h2 className="text-lg font-bold mb-3">
              Thank You 🙌
            </h2>
            <p className="text-sm mb-4">
              Your checkout was successful.
              Would you like to give feedback?
            </p>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => {
                  window.open("https://your-feedback-link.com", "_blank");
                }}
                className="bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
              >
                Give Feedback
              </button>
              <button
                onClick={() => {
                  setShowFeedbackPopup(false);
                  setSelectedTable(null);
                  navigate("/dashboard");
                }}
                className="bg-gray-600 text-white py-2 rounded hover:bg-gray-700"
              >
                Exit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ ORDER SUCCESS POPUP */}
      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center">
          <div className="bg-gray-900 p-6 rounded-lg w-80 shadow-xl text-center">
            <h2 className="text-2xl font-bold text-green-400 mb-3">✅ Order Placed</h2>
            <p className="text-gray-300 mb-4">Your order has been placed successfully.</p>
            <button
              onClick={() => setShowSuccessPopup(false)}
              className="w-full bg-green-600 hover:bg-green-700 py-2 rounded font-bold"
            >
              OK
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

export default SelfOrderByOtp;